import styled, { css } from "styled-components"

const largeStyle = ({ large }) => {
  if (large) {
    return css`
      padding: 20px;
      border-radius: 10px;
      font-size: 1.5em;
    `
  } else {
    return css`
      padding: 8px;
      border-radius: 4px;
      font-size: 1em;
    `
  }
}

const Button = styled.button`
  color: #fff;
  background: ${(p) =>
    p.primary ? p.theme.primaryColor : p.theme.secondaryColor};
  font-weight: bold;
  box-shadow: none;
  border: none;
  width: 100%;
  display: block;
  white-space: none;
  cursor: pointer;

  ${largeStyle}

  &:disabled {
    background: #eee;
    color: #666;
    cursor: default;
  }
`

export default Button
